import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";

export const Route = createFileRoute("/admin/subscribers")({
  component: () => (
    <ProtectedRoute>
      <AdminSubscribers />
    </ProtectedRoute>
  ),
});
